import React, { useState, useEffect } from 'react';
import '../EditableCard.css';
import { Link, useNavigate } from 'react-router-dom';
import { COLORS } from '../colors';
import api from '../../Services/api';
import { Card, CardContent, Typography, TextField,Menu, Select, MenuItem, Button, Divider } from '@mui/material';
import 'font-awesome/css/font-awesome.min.css';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import { FaFileDownload } from "react-icons/fa";
import { MdFileOpen, MdRemoveRedEye, MdDelete, MdEditDocument } from "react-icons/md";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
const currentYear = new Date().getFullYear();

const years = Array.from({ length: currentYear - 2020 + 1 }, (x, i) => 2020 + i);
     const titles = [
  
    "GST Certificate",
    "Trade Licence Reg And Renewal",
    "Factory Licence",
    "Building Plan Layout",
    "Stability Certificate",
    "Concern To Establishment",
    "Concern To Operations",
    "Fire Advisory",
    "Fire NOC",
   
    "Environment Clearance",
    "Medical Hospital Certificate",
    "PSARA Licence",
    "FSSAI Licence",
    "Manager Change",
    "EPFO Allotment Copy",
    "ESIC Allotment Copy",
    "PTax RC Number",
    "PT EC Number",
    "LWF Number",
    "CLRARC",
    "SandCERC",
    "BOCWRC",
    "ISMWRC",
    "Apprenticeship Registration",
    "NEEMNAPS Registration",
    "WC Policy Number",
    "Standing Order",
    "Shift Approval",
    "Display Of Notice Containing Abstracts",
    "Hazardous waste Disposal Approval",
    "Biomedical Waste Approval",
    "Boiler Amendment",
    "Analysis Fee Payment",
    "Compliance Certificate",
    "ESG Policy",
    "Policy On POSH Act 2013",
    "POSH Internal Committee",
    "CompanyIncorporationNumber",
"Enviornmental Policy",
"HumanRights Policy",
"Diversity Policy",
"Whistle blower Policy",
"Audit Committee",
"Nomination And Remuneration Committee",
"CSR Committee",
"CSR Policy And Strategy",
"Risk Management Committee",
"Sustainability Committee",
"Code Of Business Ethics And Conduct",
"Policy On Related Party Transactions Disclosed",
    
  
  ];
const titleKeyMap = {
  "GST Certificate": "GSTCertificate",
  "Trade Licence Reg And Renewal": "TradeLicenceRegAndRenewal",
  "Factory Licence": "FactoryLicence",
  "Building Plan Layout": "BuildingPlanLayout",
  "Stability Certificate": "StabilityCertificate",
  "Concern To Establishment": "ConcernToEstablishment",
  "Concern To Operations": "ConcernToOperations",
  "Fire Advisory": "FireAdvisory",
  "Fire NOC": "FireNOC",
 
  "Environment Clearance": "EnvironmentClearance",
  "Medical Hospital Certificate": "MedicalHospitalCertificate",
  "PSARA Licence": "PSARALicence",
  "FSSAI Licence": "FSSAILicence",
  "Manager Change": "ManagerChange",
  "EPFO Allotment Copy": "EPFOAllotmentCopy",
  "ESIC Allotment Copy": "ESICAllotmentCopy",
  "PTax RC Number": "PTaxRCNumber",
  "PT EC Number": "PTECNumber",
  "LWF Number": "LWFNumber",
  "CLRARC": "CLRARC",
  "SandCERC": "SandCERC",
  "BOCWRC": "BOCWRC",
  "ISMWRC": "ISMWRC",
  "Apprenticeship Registration": "ApprenticeshipRegistration",
  "NEEMNAPS Registration":"NEEMNAPSRegistration",
  "WC Policy Number": "WCPolicyNumber",
  "Standing Order": "StandingOrder",
 
  "Shift Approval": "ShiftApproval",
    "Display Of Notice Containing Abstracts": "DisplayOfNoticeContainingAbstracts",
  "Hazardous waste Disposal Approval": "HazardouswasteDisposalApproval",
  "Biomedical Waste Approval": "BiomedicalWasteApproval",
  "Boiler Amendment":"BoilerAmendment",
  "Analysis Fee Payment": "AnalysisFeePayment",
  "Compliance Certificate": "ComplianceCertificate",
  "ESG Policy": "ESGPolicy",
  "Policy On POSH Act 2013": "PolicyOnPOSHAct2013",
  "POSH Internal Committee": "POSHInternalCommittee",
 "Company Incorporation Number" : "CompanyIncorporationNumber",
"Environmental Policy":"EnvironmentalPolicy",
"HumanRights Policy":"HumanRightsPolicy",
"Diversity Policy":"DiversityPolicy",
"Whistle blower Policy":"WhistleblowerPolicy",
"Audit Committee":"AuditCommittee",
"Nomination And Remuneration Committee":"NominationAndRemunerationCommittee",
"CSR Committee":"CSRCommittee",
"CSR Policy And Strategy":"CSRPolicyAndStrategy",
"Risk Management Committee":"RiskManagementCommittee",
"Sustainability Committee":"SustainabilityCommittee",
"Code Of Business Ethics And Conduct":"CodeOfBusinessEthicsAndConduct",
"Policy On Related Party Transactions Disclosed":"PolicyOnRelatedPartyTransactionsDisclosed",

};


const MasterDataEstablishmentTable = () => {
 
  const [EstablishmentData, setEstablishmentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [establishment, setEstablishment] = useState([]);
  const [userType, setUserType] = useState('');
  const [clients, setClients] = useState([]);
  const [completedCheckboxes, setCompletedCheckboxes] = useState(new Array(titles.length).fill(false));
  const [rejectedCheckboxes, setRejectedCheckboxes] = useState(new Array(titles.length).fill(false));
  const [AssessorRemark, setAssessorRemark] = useState(new Array(titles.length).fill(''));
  const [clientRemark, setclientRemark] = useState(new Array(titles.length).fill(''));
  const [savedStatus, setSavedStatus] = useState(new Array(titles.length).fill(false));
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
  const [companyId, setCompanyId] = useState("");
  const [selectedVendorDetails, setSelectedVendorDetails] = useState('');
  const [openedDocs, setOpenedDocs] = useState({});

  const [assessorFormData, setAssessorFormData] = useState({
    assessorCompanyName: '',
    assessorId: '',
    companyId: ''
  });
  const [clientFormData, setClientFormData] = useState({
    clientName: '',
    companyId: '',
    principleEmployer: '',
    companyAddress: '',
    placeName: '',
    clientContactPersonName: '',
    clientContactPersonEmailId: '',
    clientContactPersonPhoneNumber: '',
    stateId: ''
  });
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [activeRemarkIndex, setActiveRemarkIndex] = useState(null);
  const [editableRows, setEditableRows] = useState(new Array(titles.length).fill(false));
  
  const suggestionOptions = ["Verified Ok", "InComplete", "Wrong document", "OverDue", "Other"];
    const [menuOptions, setMenuOptions] = useState(suggestionOptions);
  

  useEffect(() => {
    const sessionData = sessionStorage.getItem('user');
    const parsed = JSON.parse(sessionData);
    const id = parsed.id;
    const type = parsed.type;
    setUserType(type);
    if (type === 'assessor') {
      api.assessor.findOne(id)
        .then(response => {
          const assessorInfo = response.data.data;
          const companyIdFromAssessor = assessorInfo.companyId;
          setAssessorFormData(assessorInfo);
          setCompanyId(companyIdFromAssessor); // set this first
          if (companyIdFromAssessor) {
            fetchEstablishment(assessorInfo.companyId);
          }
          else {
            setErrorSnackbarOpen(true)
            setSnackbarErrorMessage("Fetching data failed, please try again later")
          }// call with the correct companyId

        })
        .catch(error => {
          console.error('Error fetching company data:', error);
          setLoading(false);
        });
    } else if (type === 'admin') {
      fetchClient();
    }
  }, [userType]); // Only run once on mount





  const fetchClient = async () => {
    try {
      const response = await api.client.getClients();

      if (response.status === 200) {

        setClients(response.data);
        setLoading(false)
      }
      else {
        setClients([])
        setLoading(false)
      }

    } catch (error) {
      console.error("Vendor ID could not be fetched:", error);
    }


  };

  useEffect(() => {
    setAssessorRemark(new Array(titles.length).fill(''));
  }, [titles.length]);


  useEffect(() => {
    if (userType === 'assessor' && companyId) {
      fetchEstablishmentMasterData(companyId);
    }
  }, [companyId, userType]);

const openSuggestionMenu = (index) => (e) => {
  setActiveRemarkIndex(index);

  // Logic to show options based on checkbox state
  if (completedCheckboxes[index]) {
    // Accepted: show only Verified Ok and Other
    setMenuOptions(["Verified Ok", "Other"]);
  } else if (rejectedCheckboxes[index]) {
    // Rejected: show all except Verified Ok
    setMenuOptions(suggestionOptions.filter(opt => opt !== "Verified Ok"));
  } else {
    // Default: show all
    setMenuOptions(suggestionOptions);
  }

  setMenuAnchorEl(e.currentTarget);
};


const closeSuggestionMenu = () => {
  setMenuAnchorEl(null);
  setActiveRemarkIndex(null);
};

const handleSelectSuggestion = (option) => {
  if (activeRemarkIndex === null) return;
  setMenuAnchorEl(null);

  // set value
  setAssessorRemark(prev => {
    const next = [...prev];
    next[activeRemarkIndex] = option === "Other" ? "" : option;
    return next;
  });

  // toggle editability for that row only
  setEditableRows(prev => {
    const next = [...prev];
    next[activeRemarkIndex] = option === "Other";
    return next;
  });

  // mark “unsaved”
  setSavedStatus(prev => {
    const next = [...prev];
    next[activeRemarkIndex] = false;
    return next;
  });
};

const safeHandleRemarkChange = (index, value) => {
  if (!editableRows[index]) return;   // ignore typing unless “Other”
  const next = [...AssessorRemark];
  next[index] = value;
  setAssessorRemark(next);
  setSavedStatus(prev => {
    const s = [...prev];
    s[index] = false;
    return s;
  });
};
  const fetchEstablishment = async (companyId) => {
    try {
      const response = await api.client.getClient(companyId);
      if (response.status === 200) {
        const data = response.data.data;
        setEstablishment(data);
        setLoading(false)


      }
      else if (response.status === 400) {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setEstablishment([])
      }
      else if (response.status === 404) {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setEstablishment([])
        setLoading(false)
      }
      else if (response.status === 500) {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setEstablishment([])
        setLoading(false)
      }
      else {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage("Some error occured, please try again")
        setEstablishment([])
        setLoading(false)
      }
    } catch (error) {
      console.error("Vendor ID could not be fetched:", error);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === 'clientName') {

      api.client.getClients().then(response => {
        const selectedClient = response.data.find(client => client.companyId === value);
        if (selectedClient) {
          const { companyId, clientName } = selectedClient;

          setClientFormData(prevState => ({
            ...prevState,
            clientName,
            companyId,
          }));

          setCompanyId(companyId); // Still keep this for consistency

          // Only call fetch if selectedYear is already set
          if (companyId) {
            fetchEstablishmentMasterData(companyId);
          }

          setCompletedCheckboxes('');
          setRejectedCheckboxes('');
          setAssessorRemark('')
          setclientRemark('')
          setSavedStatus(Array(titles.length).fill(false));
        }

      })
        .catch(error => {
          console.error('Error fetching vendor details:', error);

        });
    }






    if (name !== 'clientName' && name !== 'assessorName') {
      setClientFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const fetchEstablishmentMasterData = async (companyId) => {

    try {
      const response = await api.client.getClientMasterData(companyId);
      if (response.status === 200) {
     const backendData = response.data.data;
        setEstablishmentData(response.data.data);
        const newCompletedCheckboxes = [];
        const newRejectedCheckboxes = [];
        const newAssessorRemark = [];
        const newclientAssessorRemark = [];
        const newSavedStatus = [...savedStatus];
   titles.forEach((title, i) => {
         const backendKey = titleKeyMap[title]; // ✅ get mapped backend key
        const rowData = backendData[backendKey];
          if (rowData) {
            if (rowData.validation === 2) {
              newCompletedCheckboxes[i] = true;
              newRejectedCheckboxes[i] = false;
              newAssessorRemark[i] = rowData.AssessorRemark;
              newclientAssessorRemark[i] = rowData.clientRemark;
              newSavedStatus[i] = true;
              setSavedStatus(newSavedStatus);

            } else if (rowData.validation === 3) {
              newCompletedCheckboxes[i] = false;
              newRejectedCheckboxes[i] = true;
              newAssessorRemark[i] = rowData.AssessorRemark;
              newclientAssessorRemark[i] = rowData.clientRemark;
              newSavedStatus[i] = true;
              setSavedStatus(newSavedStatus);

            } else if (rowData.validation === 1) {
              newCompletedCheckboxes[i] = false;
              newRejectedCheckboxes[i] = false;
              newAssessorRemark[i] = rowData.AssessorRemark;
              newclientAssessorRemark[i] = rowData.clientRemark;
              newAssessorRemark[i] = " ";

            }
            else {
              newCompletedCheckboxes[i] = false;
              newRejectedCheckboxes[i] = false;
              newAssessorRemark[i] = " ";
              newclientAssessorRemark[i] = "";
            }

          }

        }
      )

        setCompletedCheckboxes(newCompletedCheckboxes);
        setRejectedCheckboxes(newRejectedCheckboxes);
        setAssessorRemark(newAssessorRemark);
        setclientRemark(newclientAssessorRemark);
      }
      else if (response.status === 404) {

        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setEstablishmentData(null);
        setSavedStatus(false);
        setCompletedCheckboxes([]);
        setRejectedCheckboxes([]);
        setAssessorRemark([]);
        setclientRemark([]);
        setSavedStatus(Array(titles.length).fill(false));
      }
      else if (response.status === 400) {

        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setEstablishmentData(null);
        setSavedStatus(false);
        setCompletedCheckboxes([]);
        setRejectedCheckboxes([]);
        setAssessorRemark([]);
        setclientRemark([]);
        setSavedStatus(Array(titles.length).fill(false));
      }
      else if (response.status === 500) {

        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setEstablishmentData(null);
        setSavedStatus(false);
        setCompletedCheckboxes([]);
        setRejectedCheckboxes([]);
        setAssessorRemark([]);
        setclientRemark([]);
        setSavedStatus(Array(titles.length).fill(false));
      }
      else {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage("Error fetching details");
        setEstablishmentData(null);
        setSavedStatus(false);
        setCompletedCheckboxes([]);
        setRejectedCheckboxes([]);
        setAssessorRemark([]);
        setclientRemark([]);
        setSavedStatus(Array(titles.length).fill(false));
      }

    }
    catch (error) {
      console.error("Error!,please try again", error);

    }
  };



  const handleCheckboxChange = (index, column) => {
    
      const fileUrl = EstablishmentData[Object.keys(EstablishmentData)[index]]?.fileUrl;

    if (fileUrl && !openedDocs[index]) {
    // show inline warning instead of alert
    setErrorSnackbarOpen(true)
    setSnackbarErrorMessage('Please view the document before accepting or rejecting')
    return;
  }
    setSavedStatus(prevStatus => {
      const newStatus = [...prevStatus];
      newStatus[index] = false;
      return newStatus;


    });


    if (column === 'accepted') {
      const newCompletedCheckboxes = [...completedCheckboxes];
      newCompletedCheckboxes[index] = !newCompletedCheckboxes[index];
      // If completed checkbox is clicked, disable the rejected checkbox
      if (newCompletedCheckboxes[index]) {
        const newRejectedCheckboxes = [...rejectedCheckboxes];
        newRejectedCheckboxes[index] = false;
        setRejectedCheckboxes(newRejectedCheckboxes);
        const newAssessorRemark = [...AssessorRemark];
        newAssessorRemark[index] = 'Verified Ok';
        setAssessorRemark(newAssessorRemark);

      }
      setCompletedCheckboxes(newCompletedCheckboxes);


    } else if (column === 'rejected') {
      const newRejectedCheckboxes = [...rejectedCheckboxes];
      newRejectedCheckboxes[index] = !newRejectedCheckboxes[index];
      // If rejected checkbox is clicked, disable the completed checkbox
      if (newRejectedCheckboxes[index]) {
        const newCompletedCheckboxes = [...completedCheckboxes];
        newCompletedCheckboxes[index] = false;
        setCompletedCheckboxes(newCompletedCheckboxes);
        const newAssessorRemark = [...AssessorRemark];
        newAssessorRemark[index] = '';
        setAssessorRemark(newAssessorRemark);
      }
      setRejectedCheckboxes(newRejectedCheckboxes);

    }
  };
 

  const handleSave = async (index, title) => {

    if (!companyId) {
      // window.alert("Please select a vendor");
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage('Please select Establishment!');


      return;
    }

    const newSavedStatus = [...savedStatus];
    const masterdata = {
      companyId: companyId,
      //   year: selectedYear
    };
    console.log(companyId,"id")

    if (index === 0) {
      masterdata.GSTCertificate = {
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].Unit,
       
        fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee, 
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };

    }
    if (index === 1) {
      masterdata.TradeLicenceRegAndRenewal = {
       
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,

fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };

    }

    if (index === 2) {
      masterdata.FactoryLicence = {
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,

fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee, 
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1),
        validDate: EstablishmentData[Object.keys(EstablishmentData)[index]].validDate, // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 3) {
      masterdata.BuildingPlanLayout = {
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee,
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,
        
fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 4) {
      masterdata.StabilityCertificate = {
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,

        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 5) {
      masterdata.ConcernToEstablishment = {
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,

        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 6) {
      masterdata.ConcernToOperations = {
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,

        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 7) {
      masterdata.FireAdvisory = {
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,

        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee, 
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 8) {
      masterdata.FireNOC = {
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,

        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee,
        validDate: EstablishmentData[Object.keys(EstablishmentData)[index]].validDate,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 9) {

      masterdata.EnvironmentClearance = {
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,

        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee, 
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 10) {
      masterdata.MedicalHospitalCertificate = {
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,
       
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee,
        validDate: EstablishmentData[Object.keys(EstablishmentData)[index]].validDate,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 11) {
      masterdata.PSARALicence = {
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,

        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 12) {
      masterdata.FSSAILicence = {
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,

        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 13) {
      masterdata.ManagerChange = {

        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 14) {
      masterdata.EPFOAllotmentCopy = {
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,

        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 15) {
      masterdata.ESICAllotmentCopy = {
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,

        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee,
        validDate: EstablishmentData[Object.keys(EstablishmentData)[index]].validDate,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 16) {
      masterdata.PTaxRCNumber = {
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,

        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 17) {
      masterdata.PTECNumber = {
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,

        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 18) {
      masterdata.LWFNumber = {
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,

        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 19) {
      masterdata.CLRARC = {
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,

        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 20) {
      masterdata.SandCERC = {
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,

        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 21) {
      masterdata.BOCWRC = {
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,

        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee,
        validDate: EstablishmentData[Object.keys(EstablishmentData)[index]].validDate,
        noOfWorkers: EstablishmentData[Object.keys(EstablishmentData)[index]].noOfWorkers,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 22) {
      masterdata.ISMWRC = {
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,

        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
       fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee,
        validDate: EstablishmentData[Object.keys(EstablishmentData)[index]].validDate,
        noOfWorkers: EstablishmentData[Object.keys(EstablishmentData)[index]].noOfWorkers,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 23) {

      masterdata.ApprenticeshipRegistration = {
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,
       
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee, 
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 24) {

      masterdata.NEEMNAPSRegistration = {
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,
        
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
       fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee,
        validDate: EstablishmentData[Object.keys(EstablishmentData)[index]].validDate,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 25) {
      masterdata.WCPolicyNumber = {
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,
      
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        validDate: EstablishmentData[Object.keys(EstablishmentData)[index]].validDate,

        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }

    if (index === 26) {
      masterdata.StandingOrder = {
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        validDate: EstablishmentData[Object.keys(EstablishmentData)[index]].validDate,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,

        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 27) {
      masterdata.ShiftApproval = {
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        validDate: EstablishmentData[Object.keys(EstablishmentData)[index]].validDate,
        noOfWorkers: EstablishmentData[Object.keys(EstablishmentData)[index]].noOfWorkers,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 28) {
      masterdata.DisplayOfNoticeContainingAbstracts = {
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        validDate: EstablishmentData[Object.keys(EstablishmentData)[index]].validDate,
fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 29) {
      masterdata.HazardouswasteDisposalApproval = {
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 30) {
      masterdata.BiomedicalWasteApproval = {
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
       fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 31) {
      masterdata.BoilerAmendment = {
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,

        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
       fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 32) {
      masterdata.AnalysisFeePayment = {
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,

        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
       
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
     if (index === 33) {
      masterdata.ComplianceCertificate = {
        Unit: EstablishmentData[Object.keys(EstablishmentData)[index]].unit,

        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
       
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 34) {
      masterdata.ESGPolicy = {

        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
       fee: EstablishmentData[Object.keys(EstablishmentData)[index]].fee,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
     if (index === 35) {
      masterdata.PolicyOnPOSHAct2013 = {
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
       if (index === 36) {
      masterdata.POSHInternalCommittee = {
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
      if (index === 37) {
      masterdata.CompanyIncorporationNumber = {
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
      if (index === 38) {
      masterdata.EnvironmentalPolicy = {
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
      if (index === 39) {
      masterdata.HumanRightsPolicy = {
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
      if (index === 40) {
      masterdata.DiversityPolicy = {
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
      if (index === 41) {
      masterdata.WhistleblowerPolicy = {
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
      if (index === 42) {
      masterdata.AuditCommittee = {
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
     if (index === 43) {
      masterdata.NominationAndRemunerationCommittee = {
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
     if (index === 44) {
      masterdata.CSRCommittee = {
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
     if (index === 45) {
      masterdata.CSRPolicyAndStrategy = {
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
     if (index === 46) {
      masterdata.RiskManagementCommittee = {
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
     if (index === 47) {
      masterdata.SustainabilityCommittee = {
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
     if (index === 48) {
      masterdata.CodeOfBusinessEthicsAndConduct = {
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }
    if (index === 49) {
      masterdata.PolicyOnRelatedPartyTransactionsDisclosed = {
        value: EstablishmentData[Object.keys(EstablishmentData)[index]].value,
        fileUrl: EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,
        validation: completedCheckboxes[index] ? 2 : (rejectedCheckboxes[index] ? 3 : 1), // Assuming 1 for pending
        AssessorRemark: AssessorRemark[index],
        clientRemark: clientRemark[index],
        na: (EstablishmentData[Object.keys(EstablishmentData)[index]].na === false ? false : true)
      };
    }

    try {
      const response = await api.client.updateClientMasterData(masterdata);
      if (response.status === 200) {

        newSavedStatus[index] = true;
        setSavedStatus(newSavedStatus);
        setSnackbarOpen(true);
        setSnackbarMessage('Saved Successfully!');
        try {
          // console.log('Calling assessorToMail with payload:', payload);
          const response = await api.assessor.fromAssessorMasterdataMail({ companyId: companyId });

          if (response.status === 200) {
            setSnackbarOpen(true);
            setSnackbarMessage(response.data.message);
          }
          else if (response.status === 400) {
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage(response.data.message);
          }
          else if (response.status === 404) {
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage(response.data.message);
          }
          else if (response.status === 500) {
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage(response.data.message);
          } else {
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage(response.data.message);
          }
        } catch (emailErr) {
          console.error('assessorToMail error:', emailErr);
          setErrorSnackbarOpen(true);
          setSnackbarErrorMessage(emailErr?.response?.data?.message);
        }
      }
      else if (response.status === 404) {

        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage('There is no masterdata available assosiated with this Id');


      }
      else if (response.status === 400) {

        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage('Data not updated, Please try again');

      }


    } catch (error) {
      console.error("Error updating status", error);


    };
  }




  const handleViewDocument = (fileUrl,index) => {
    setOpenedDocs(prev => ({ ...prev, [index]: true }));
    window.open(`https://docs.google.com/gview?url=${fileUrl}&embedded=true`, '_blank')
  };



  const rows = titles.map((title, index) => {

    let rowClassName = '';
    if (EstablishmentData && EstablishmentData[Object.keys(EstablishmentData)[index]]) {
      const validationStatus = EstablishmentData[Object.keys(EstablishmentData)[index]].validation;
      if (validationStatus === 1) {
        rowClassName = 'pending';
      } else if (validationStatus === 2) {
        rowClassName = 'accepted';
      } else if (validationStatus === 3) {
        rowClassName = 'rejected';
      }

    }
    if (completedCheckboxes[index]) {
      rowClassName = 'accepted';
    } else if (rejectedCheckboxes[index]) {
      rowClassName = 'rejected';
    }
    let filename = '';
    if (
      EstablishmentData &&
      EstablishmentData[Object.keys(EstablishmentData)[index]] &&
      EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl
    ) {
      const fullUrl = EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl;
      filename = fullUrl.substring(fullUrl.lastIndexOf('/') + 1);
    }
    return (
      <>

        <tr key={`row-${index}-${title}`} className={rowClassName} >
          <td>{title}</td>
          {EstablishmentData && (
                  <td className='text-secondary'>
                  
                  {EstablishmentData[Object.keys(EstablishmentData)[index]]?.Category}
          </td>
          )}
          <td>
            {EstablishmentData && (
              <div
                style={{
                  overflowX: 'auto',
                  overflow: 'auto',
                  width: '200px',
                  height: EstablishmentData[Object.keys(EstablishmentData)[index]]?.validDate && EstablishmentData[Object.keys(EstablishmentData)[index]]?.noOfWorkers ? '100px' : 'auto',
                }}
              >
                <p>
                  {EstablishmentData[Object.keys(EstablishmentData)[index]]?.value}<br/>
                  {EstablishmentData[Object.keys(EstablishmentData)[index]]?.Unit ? `Unit: ${EstablishmentData[Object.keys(EstablishmentData)[index]]?.Unit  }` : ''}


                  <br />
                  {EstablishmentData[Object.keys(EstablishmentData)[index]]?.fee ? `Value: ${EstablishmentData[Object.keys(EstablishmentData)[index]]?.fee  }` : ''}
                   <br/>
                  {EstablishmentData[Object.keys(EstablishmentData)[index]]?.validDate ? `Valid Date: ${EstablishmentData[Object.keys(EstablishmentData)[index]].validDate?.slice(0, 10).split('-').reverse().join('-')}` : null}
                  <br />
                  {EstablishmentData[Object.keys(EstablishmentData)[index]]?.noOfWorkers ? `No. of Workers: ${EstablishmentData[Object.keys(EstablishmentData)[index]].noOfWorkers}` : null}
                </p>
              </div>

            )}
          </td>

          <td>   {EstablishmentData && (
            <>

              {filename && (
                <div className="d-flex gap-3 align-items-center" >
                  <button className='flex flex-col items-center text-sm text-green-700' onClick={() => handleViewDocument(EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl,index)}><MdFileOpen className="text-xl text-success" /> View</button>
                  <a download className="flex flex-col items-center text-sm text-blue-700" href={EstablishmentData[Object.keys(EstablishmentData)[index]].fileUrl}><FaFileDownload className="text-xl text-primary" />Download</a>
                </div>

              )}
            </>
          )}</td>
          <td>   {EstablishmentData && (
            <>

              <p>{EstablishmentData[Object.keys(EstablishmentData)[index]]?.na === false ? "Applicable" : "Not Applicable"}</p>
            </>
          )}</td>

          <td>
            <input
              type="checkbox"
              checked={completedCheckboxes[index]}
              onChange={() => handleCheckboxChange(index, 'accepted')}
            />
          </td>
          <td>
            <input
              type="checkbox"
              checked={rejectedCheckboxes[index]}
              onChange={() => handleCheckboxChange(index, 'rejected')}
            />
          </td>
          <td className="remark">
             <div style={{ position: 'relative' }}>
    <textarea
      className="p-2"
   
      value={AssessorRemark[index] || ''}
      placeholder={!AssessorRemark[index] ? 'Enter your remarks here' : 'Enter your remarks here'}
      readOnly={!editableRows[index]}  // lock unless Other
      onChange={e => safeHandleRemarkChange(index, e.target.value)}
      rows={3}
      style={{
        width: '100%',
        border: '1px solid lightgray',
        borderRadius: 4,
        paddingRight: 90,           
       
      }}
    />
 <button
      type="button"
      onClick={openSuggestionMenu(index)}
      style={{
        position: 'absolute',
        right: 10,
        bottom: 8,
        fontSize: 15,
        color: 'blue',
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: 0,
      }}
    >
     <ArrowDropDownIcon/>
    </button>
  </div>
          

            {EstablishmentData && (
              <>
                {EstablishmentData && EstablishmentData[Object.keys(EstablishmentData)[index]]?.clientRemark && (
                  <p className="p-2" style={{ width: '200px', overflow: 'auto', height: '100px', border: '1px solid lightgray', color: 'red' }}>Establishment Remark: {EstablishmentData[Object.keys(EstablishmentData)[index]].clientRemark}</p>
                )}
              </>
            )}
          </td>
<Menu
  anchorEl={menuAnchorEl}
  open={Boolean(menuAnchorEl)}
  onClose={closeSuggestionMenu}
  PaperProps={{
    elevation: 0,
    sx: {
      border: "1px solid #e0e0e0",
      minWidth: 150,
    },
  }}
>
  {menuOptions.map((opt) => (
    <MenuItem
      key={opt}
      onClick={() => handleSelectSuggestion(opt)}
      sx={{ fontSize: "0.8rem", padding: "6px", textAlign: "center" }}
    >
      {opt}
    </MenuItem>
  ))}
</Menu>
          <td>
            <button type="submit" className="btn btn-md btn-outline-dark" onClick={() => handleSave(index, title)} disabled={savedStatus[index] === true || (!completedCheckboxes[index] && !rejectedCheckboxes[index]) || (rejectedCheckboxes[index] && !AssessorRemark[index]?.trim())}> {savedStatus[index] ? "Saved" : "Save"}</button>
          </td>
        </tr>

      </>
    );
  });


  const renderDropdowns = () => {
    if (userType === 'admin') {
      return (



        <div className="mt-2 mx-3 d-flex justify-content-end">

          <Select value={clientFormData.companyId} onChange={handleChange} name="clientName" displayEmpty
            style={{ height: "35px", minWidth: '250px', maxWidth: '300px' }}>
            <MenuItem value="" disabled>Select Establishment</MenuItem>
            {Array.isArray(clients) && clients.map((client, index) => (
              <MenuItem key={client.companyId} value={client.companyId}>
                {client.clientName}, {client.stateId}
              </MenuItem>
            ))}
          </Select>
        </div>

      );
    } else {
      return (
        <>
        </>
      );
    }
  };


  return (
    <>
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',

        }}
        severity="success"
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackbarOpen(false)}
        sx={{
          marginTop: '2.9%',
          marginRight: '7%'
        }}
      >
        <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
      </Snackbar>
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        severity="error"
        open={errorSnackbarOpen}
        autoHideDuration={2000}
        sx={{
          marginTop: '2.9%',
          marginRight: '7%'
        }}
        onClose={() => { setErrorSnackbarOpen(false) }}
      >
        <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
      </Snackbar>
      {loading ? (
        <div className=" d-flex flex-row align-items-center justify-content-center" style={{ marginTop: '80px' }}>
          <h3 >Loading</h3>
          <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem', marginLeft: '10px' }} role="status"></div>
          <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem', marginLeft: '10px' }} role="status"></div>
          <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem', marginLeft: '10px' }} role="status"></div>

        </div>
      ) :
        userType === 'assessor' ? (
          establishment ? (
            <div className="d-grid mt-3">
              {/* Status legend */}
              <div style={{ letterSpacing: '1px' }}>
                <div
                  style={{
                    backgroundColor: COLORS.bggray,
                    width: '15px',
                    height: '15px',
                    display: 'inline-block',
                    marginRight: '4px',
                    marginLeft: '10px',
                    borderRadius: '50%',
                  }}
                ></div>
                <span style={{ fontSize: '14px' }}>Under review</span>
                <div className="vr mx-3"></div>
                <div
                  style={{
                    backgroundColor: COLORS.success,
                    width: '15px',
                    height: '15px',
                    display: 'inline-block',
                    marginRight: '4px',
                    borderRadius: '50%',
                  }}
                ></div>
                <span style={{ fontSize: '14px' }}>Accepted</span>
                <div className="vr mx-3"></div>
                <div
                  style={{
                    backgroundColor: COLORS.danger,
                    width: '15px',
                    height: '15px',
                    display: 'inline-block',
                    marginRight: '4px',
                    borderRadius: '50%',
                  }}
                ></div>
                <span style={{ fontSize: '14px' }}>Rejected</span>
              </div>


              <div>{renderDropdowns()}</div>

              <div style={{ maxHeight: '400px', marginTop: '20px', overflowY: 'auto' }}>
                <table className="mt-0 pt-0" style={{ width: '100%' }}>
                  <thead className="position-sticky top-0" style={{ zIndex: 10, backgroundColor: 'inherit' }}>
                    <tr className="text-white bg-dark">
                      <th>Name of DOC</th>
                      <th>Category</th>

                      <th>Date/Doc No</th>
                      <th>Uploaded File</th>
                      <th>Not Applicable/Applicable</th>
                      <th>Accepted</th>
                      <th>Rejected</th>
                      <th>Observation</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedVendorDetails && (
                      <tr>
                        <div>
                          <h6 className="p-3">
                            Nature of Work: <span className="fw-bold">{selectedVendorDetails.natureOfWork}</span>
                          </h6>
                        </div>
                      </tr>
                    )}
                    {rows}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div style={{ marginTop: '60px' }}>
              <p className="text-center text-dark">
                No establishment Found !! <Link to="/createVendor" className="text-danger">Click here</Link> to Create
              </p>
            </div>
          )
        ) : userType === 'admin' ? (
          establishment ? (
            <div className="mt-3">
              {/* Same table and status bar reused for admin */}
              <div style={{ letterSpacing: '1px' }}>
                <div
                  style={{
                    backgroundColor: COLORS.bggray,
                    width: '15px',
                    height: '15px',
                    display: 'inline-block',
                    marginRight: '4px',
                    marginLeft: '8px',
                    borderRadius: '50%',
                  }}
                ></div>
                <span style={{ fontSize: '14px' }}>Under review</span>
                <div className="vr mx-3"></div>
                <div
                  style={{
                    backgroundColor: COLORS.success,
                    width: '15px',
                    height: '15px',
                    display: 'inline-block',
                    marginRight: '4px',
                    borderRadius: '50%',
                  }}
                ></div>
                <span style={{ fontSize: '14px' }}>Accepted</span>
                <div className="vr mx-3"></div>
                <div
                  style={{
                    backgroundColor: COLORS.danger,
                    width: '15px',
                    height: '15px',
                    display: 'inline-block',
                    marginRight: '4px',
                    borderRadius: '50%',
                  }}
                ></div>
                <span style={{ fontSize: '14px' }}>Rejected</span>
              </div>

              <div>{renderDropdowns()}</div>

              <div style={{ maxHeight: '400px', marginTop: '10px', overflowY: 'auto' }}>
                <table className="mt-0 pt-0" style={{ width: '100%' }}>
                  <thead className="position-sticky top-0" style={{ zIndex: 10, backgroundColor: 'inherit' }}>
                    <tr className="text-white bg-dark">
                      <th>Name of DOC</th>
                      <th>Category</th>

                      <th>Date/Doc No</th>
                      <th>Uploaded File</th>
                      <th>Not Applicable/Applicable</th>
                      <th>Accepted</th>
                      <th>Rejected</th>
                      <th>Observation</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedVendorDetails && (
                      <tr>
                        <td colSpan="8">
                          <h6 className="px-3 pt-2 pb-2">
                            Nature of Work: <span className="fw-bold">{selectedVendorDetails.natureOfWork}</span>
                          </h6>
                        </td>
                      </tr>
                    )}
                    {rows}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div style={{ marginTop: '60px' }}>
              <p className="text-center text-dark">
                No Clients Found !! <Link to="/createCompany" className="text-danger">Click here</Link> to Create
              </p>
            </div>
          )
        ) : null}



    </>
  );
};


export default MasterDataEstablishmentTable;
